import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useFamilyContext } from '../context/FamilyContext';
import NFCModal from '../components/NFCModal';

const { FiPlus, FiRadio, FiZap, FiTrash2, FiEdit } = FiIcons;

export default function NFCScenes() {
  const { state, dispatch } = useFamilyContext();
  const { nfcScenes } = state;
  const [showModal, setShowModal] = useState(false);
  const [editingScene, setEditingScene] = useState(null);

  const handleSave = (sceneData) => {
    if (editingScene) {
      dispatch({ type: 'UPDATE_NFC_SCENE', payload: { ...editingScene, ...sceneData } });
      setEditingScene(null);
    } else {
      dispatch({ type: 'ADD_NFC_SCENE', payload: sceneData });
    }
  };

  const handleDelete = (id) => {
    if (confirm('Szene löschen?')) {
      dispatch({ type: 'DELETE_NFC_SCENE', payload: id });
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">NFC Automationen</h1>
          <p className="text-gray-600 mt-2">Smarthome-Steuerung mit NFC Tags</p>
        </div>
        <button
          onClick={() => { setEditingScene(null); setShowModal(true); }}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 mt-4 sm:mt-0"
        >
          <SafeIcon icon={FiPlus} className="w-4 h-4 mr-2" />
          Neuer Tag
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {nfcScenes.map((scene, index) => (
          <motion.div
            key={scene.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-white p-6 rounded-xl shadow-sm border border-gray-200"
          >
            <div className="flex items-center justify-between mb-4">
                <div className="bg-purple-100 p-3 rounded-full">
                    <SafeIcon icon={FiRadio} className="w-6 h-6 text-purple-600" />
                </div>
                <div className="flex space-x-1">
                    <button onClick={() => { setEditingScene(scene); setShowModal(true); }} className="text-gray-400 hover:text-blue-600 p-1">
                        <SafeIcon icon={FiEdit} className="w-4 h-4" />
                    </button>
                    <button onClick={() => handleDelete(scene.id)} className="text-gray-400 hover:text-red-600 p-1">
                        <SafeIcon icon={FiTrash2} className="w-4 h-4" />
                    </button>
                </div>
            </div>
            
            <h3 className="font-bold text-gray-900 mb-1">{scene.name}</h3>
            <div className="flex items-center text-sm text-gray-600 mt-2">
                <SafeIcon icon={FiZap} className="w-4 h-4 mr-2 text-yellow-500" />
                Aktion: {scene.action}
            </div>
            <div className="mt-4 pt-4 border-t border-gray-100 text-xs text-gray-400 font-mono">
                ID: {scene.tagId || 'Nicht zugewiesen'}
            </div>
          </motion.div>
        ))}
        
        {nfcScenes.length === 0 && (
             <div className="col-span-full text-center py-12 text-gray-500 bg-gray-50 rounded-xl border border-dashed border-gray-300">
                <SafeIcon icon={FiRadio} className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                Noch keine NFC Tags konfiguriert.
            </div>
        )}
      </div>

      {showModal && (
        <NFCModal
          scene={editingScene}
          onClose={() => setShowModal(false)}
          onSave={handleSave}
        />
      )}
    </div>
  );
}